var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconUpL48Filled = function SvgIconUpL48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36.3 30.83-9.8-16.6A2.888 2.888 0 0 0 24 12.8c-1.04 0-1.97.53-2.5 1.43l-9.79 16.6c-.53.89-.54 2.01-.02 2.91.52.9 1.48 1.46 2.52 1.46h19.6c1.04 0 2-.56 2.52-1.46.52-.9.51-2.02-.02-2.91h-.01Z",
    fill: "current"
  })));
};
export default SvgIconUpL48Filled;